export const SIZES = {
  small: 's',
  medium: 'm',
  large: 'l',
};

export const BACKGROUNDS = {
  dark: 'bg-dark',
  light: 'bg-light',
  red: 'bg-red'
};

export const DIVIDERS = {
  dark: 'darkBackground',
  sidebar: 'darkSidebar',
  light: 'lightBackground',
  tooltips: 'tooltips'
};

export const CREDIT_CARD_REGEXES = [
  {
    card: 'Visa',
    pattern: /^(?:4[0-9]{12}(?:[0-9]{3})?)$/,
    subPatterns: [
      /^4/, // starts with number 4
      /^(4[0-9]{1,12})/ // has 1 to 12 numbers after the initial 4
    ],
    length: 13
  },
  {
    card: 'Mastercard',
    pattern: /^(?:5[1-5][0-9]{14})$/,
    subPatterns: [
      /^5/, // starts with number 5,
      /^(5[1-5])/, // second number must be a number between 1 and 5 (including)
    ],
    length: 16
  },
  {
    card: 'AmericanExpress',
    pattern: /^3[47][0-9]{13}$/,
    subPatterns: [
      /^3/, // starts with number 3
      /^(3[47])/ // second number must be either 4 or 7
    ],
    length: 15
  },
  {
    card: 'RuPay',
    pattern: /(508[5-9][0-9]{12})|(6069[8-9][0-9]{11})|(607[0-8][0-9]{12})|(6079[0-8][0-9]{11})|(608[0-5][0-9]{12})|(6521[5-9][0-9]{11})|(652[2-9][0-9]{12})|(6530[0-9]{12})|(6531[0-4][0-9]{11})/,
    subPatterns: [
      /^(508|607|608|652)/, // starts with one of these numbers
      /^(6069|6079|6521|6530|6531)/, // starts with one of these numbers
      /^(508|6069|607|6079|608|6521|652|6530|6531){1,12}/ // has 11 or 12 numbers after the initial number
    ],
    length: 16
  }
];



// WEBPACK FOOTER //
// ./src/uis/common/constants.js